import React from 'react'
import { useHistory } from 'react-router';
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
function Venom() {
  const history = useHistory();
  let settings = {
    infinite: true,
    fade: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <div>
      <div className="battlepass_midimg width">
        <img src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-characters-bg-2880x2241-f4710adffd1b.jpg" alt="" />
      </div>

      <div className="battle_pass_stars ">
        <img src="https://cdn2.unrealengine.com/battlepass-battlestar-277x252-579065405.png" alt="" />
      </div>

      <div className="battlepass_info">
        <p>ENTER THE SIDEWAYS
        </p>
      </div>
      <div className="battlepass__own">
        <p>MY SELF - CARNAGE</p>
      </div>



      {/* logo png images1 */}
      <div className="slider_subimg_logo1 ">
        <img src="https://cdn2.unrealengine.com/18-bling-bp-tendrilsofcarnage-290x369-6633527abf8c.png" alt="" />
      </div>

      {/* logo png images2 */}
      <div className="slider_subimg_logo2  ">
        <img src="https://cdn2.unrealengine.com/layer-14-266x307-5218dc879744.png" alt="" />
      </div>

      {/* logo png images3 */}
      <div className="slider_subimg_logo3">
        <img src="https://cdn2.unrealengine.com/18-screen-loading-bp-maximumcarnage-3d-307x245-05a93a90e250.png" alt="" />
      </div>


      {/* logo png images4 */}
      <div className="slider_subimg_logo4 ">
        <img src="https://cdn2.unrealengine.com/18-spray-bp-itsallgonnaberedsoon-233x213-33178eb9645a.png" alt="" />
      </div>

      <Carousel1 {...settings}>

        <Wrap>
          <a>
            <img
              src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/7626872a-f603-4ca8-8aac-d36e9ae6a02e/der2wvz-e4cf34fc-8c23-4f21-ab27-eae87f6ec055.png/v1/fill/w_483,h_516,strp/fortnite_carnage_png_by_buizel12_der2wvz-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTE2IiwicGF0aCI6IlwvZlwvNzYyNjg3MmEtZjYwMy00Y2E4LThhYWMtZDM2ZTlhZTZhMDJlXC9kZXIyd3Z6LWU0Y2YzNGZjLThjMjMtNGYyMS1hYjI3LWVhZTg3ZjZlYzA1NS5wbmciLCJ3aWR0aCI6Ijw9NDgzIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.W1jEoHi4hFAajEFGV_iRH6TOmJfi_VIrvE63bAmUaoI" alt="" />
          </a>
        </Wrap>


      </Carousel1>



    </div>
  )
}

export default Venom


const Carousel1 = styled(Slider)`
::-webkit-scrollbar {
    width: 0;
  }
  
  margin-top: -1860px;
  margin-bottom: 220px;
  margin-left:150px;
 overflow-X:hidden;

  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;

    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }

  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 158, 171);
    }
  }

  li.slick-active button:before {
    color: white;
  }

  .slick-list {
    overflow: initial;
  }

  .slick-prev {
    left: -75px;
  }

  .slick-next {
    right: -75px;
  }
`;



const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  ::-webkit-scrollbar {
    width: 0;
  }
  

  a {
    border-radius: 4px;

    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;

    img {
      width: 60%;
      margin-left:auto;
      margin-right:auto;
      

    }
`;
